import React, { useState, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import {
  client,
  serverUrl,
  apiEndpoints,
  filesystem_root,
  subdomain,
} from "../../config";
import PostSingle from "../../partials/posts/postSingle";

export default function VideoSingle(props) {
  const [post, setPost] = useState(null);
  const params = useParams();

  const videoLoaded = (id) => {
    const videoElement = document.querySelector(`video[data-id="${id}"]`);

    new window.Plyr(videoElement, {
      controls: [
        "play-large",
        "play",
        "progress",
        "current-time",
        "mute",
        "volume",
        "fullscreen",
      ],
    });
  };

  const getPlyrEmbedUrl = (url) => {
    try {
      const u = new URL(url);

      if (u.hostname.includes("youtube.com")) {
        return `https://www.youtube.com/embed/${u.searchParams.get("v")}`;
      }
      if (u.hostname.includes("youtu.be")) {
        return `https://www.youtube.com/embed${u.pathname}`;
      }
      if (u.hostname.includes("vimeo.com")) {
        return `https://player.vimeo.com/video${u.pathname}`;
      }

      return url;
    } catch {
      return url;
    }
  };

  const renderPostVideo = (post) => {
    const autoplay = client === "equans" ? true : false;
    const id = params.id;

    let isRemote = false;
    let videoSource;

    if (client === "companyapp") {
      if (post.field_media_oembed_video) {
        videoSource = getPlyrEmbedUrl(post.field_media_oembed_video);
        isRemote = true;
      } else {
        if (!props.preview) {
          videoSource = `${filesystem_root}/${subdomain}/video/${id}/${id}/assets/${post.filename}`;
        } else {
          videoSource = `${serverUrl}/api/v2/assets?mid=${post.mid}`;
        }
      }

      const fileToken = post.file_access_token;

      if (fileToken && !isRemote) {
        if (!props.preview) {
          videoSource = `${filesystem_root}/${subdomain}/video/${id}/${id}/assets/${post.filename}?access_token=${fileToken}`;
        } else {
          videoSource = `${serverUrl}/shared/files/${post.filename}?access_token=${fileToken}`;
        }
      }
    } else {
      videoSource = `${serverUrl}${
        post.field_media_video_file
          ? post.field_media_video_file
          : post.field_video
      }`;
    }

    return (
      <div className="post-video-container" style={{ position: "relative" }}>
        {isRemote ? (
          <div className="plyr__video-embed">
            <iframe
              src={videoSource}
              allowFullscreen
              allow="autoplay; encrypted-media"
              title={post.title}
            ></iframe>
          </div>
        ) : (
          <video
            data-id={post.id}
            controls
            autoPlay={autoplay}
            className="post-video plyr"
            onLoadedMetadata={() => {
              videoLoaded(post.id);
            }}
          >
            <source src={videoSource} alt={`Video for ${post.title}`} />
          </video>
        )}
      </div>
    );
  };
  
  return (
    <PostSingle
      preview={props.preview}
      apiEndpoint={apiEndpoints.videos}
      entityFavoritesContentType={"video"}
      preview={props.preview}
      previewReturnRoute={"/videos-creator"}
      returnRoute={"/videos"}
      backBtnText={"Video Library"}
      screenClassName={"videos"}
      v2Bundle={"video"}
      logCustomEventType={"Video"}
      entityType={"video"}
      setEntityPost={(_post) => {
        setPost(_post);
      }}
    >
      {post && renderPostVideo(post)}
    </PostSingle>
  );
}